/* ============================================================================
 * BADGES DE MATERIAL EN TARJETAS DE MANÓMETROS — Motion
 * ----------------------------------------------------------------------------
 * Dos chips por manómetro para distinguir a primera vista:
 *   1) BOURDON (material interior): "Bourdon Acero Inox" (plata) / "Bourdon Latón" (dorado)
 *   2) CAJA: "Caja acero inoxidable" (plata) / "Caja lámina negra" (negro) / "Caja aluminio fundido" (gris)
 * Reglas (confirmadas por el dueño):
 *   - Bourdon: modelo con "SS" (2000SS/2005SS) = Acero Inox; el resto = Latón (bronce).
 *   - Caja: por palabra en el título → "lámina"→lámina negra (05/11/15), "aluminio"→aluminio (231),
 *     si no → acero inoxidable (SS, 251/255, CB).
 * Solo en productos type "Manómetros…"; adaptadores/racores no llevan. Autocontenido.
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__matBadges) return;
  window.__matBadges = true;

  var CONFIG = {
    cacheKey: 'mat_index_v2',
    cacheTtlMs: 15 * 60 * 1000,
    card: '.card-wrapper, product-card',
    cardInfo: '.card__information',
    productLink: 'a[href*="/products/"]',
    gridWatch: '#product-grid, .product-grid, .motion-tab-grid, .collection, main',
  };
  var EN = (document.documentElement.lang || 'es').indexOf('en') === 0;
  var BOURDON = { inox: EN ? 'Bourdon Stainless' : 'Bourdon Acero Inox', laton: EN ? 'Bourdon Brass' : 'Bourdon Latón' };
  var CAJA = {
    inox: EN ? 'Case stainless steel' : 'Caja acero inoxidable',
    lamina: EN ? 'Case black sheet steel' : 'Caja lámina negra',
    aluminio: EN ? 'Case cast aluminum' : 'Caja aluminio fundido'
  };

  function isManometro(p) { return /man[oó]metr/i.test(p.product_type || ''); }
  function bourdonOf(p) { return /\d\s*SS\b/i.test(p.title || '') ? 'inox' : 'laton'; }
  function cajaOf(p) {
    var t = p.title || '';
    if (/l[aá]mina/i.test(t)) return 'lamina';
    if (/aluminio/i.test(t)) return 'aluminio';
    return 'inox';
  }

  function injectCSS() {
    if (document.getElementById('mat-css')) return;
    var css = [
      '.mat-row{display:flex;flex-wrap:wrap;gap:5px;margin:2px 0 10px;position:relative;z-index:3;}',
      '.mat-badge{display:inline-flex;align-items:center;gap:5px;font-family:inherit;font-size:10.5px;font-weight:700;line-height:1;padding:4px 9px 4px 7px;border-radius:999px;border:1px solid;white-space:nowrap;}',
      '.mat-badge .mat-dot{width:11px;height:11px;border-radius:50%;flex:0 0 auto;box-shadow:inset 0 1px 1px rgba(255,255,255,.5),inset 0 -1px 2px rgba(0,0,0,.2);}',
      '.mat-inox{background:#eef2f6;color:#3a4657;border-color:#cfd7e0;}',
      '.mat-inox .mat-dot{background:linear-gradient(135deg,#f2f5f8 0%,#c3ccd6 45%,#8f9aa8 100%);}',
      '.mat-laton{background:#faf3df;color:#7a5a10;border-color:#e7d6a4;}',
      '.mat-laton .mat-dot{background:linear-gradient(135deg,#f3dd90 0%,#d7a83c 48%,#a9760f 100%);}',
      '.mat-lamina{background:#ecedf0;color:#2b2f36;border-color:#cfd2d8;}',
      '.mat-lamina .mat-dot{background:linear-gradient(135deg,#525760 0%,#20232a 100%);}',
      '.mat-aluminio{background:#eef0f2;color:#485059;border-color:#d3d8dd;}',
      '.mat-aluminio .mat-dot{background:linear-gradient(135deg,#e2e6ea 0%,#aab2bb 50%,#828a94 100%);}',
      '@media(max-width:749px){.mat-badge{font-size:9.5px;padding:3px 7px 3px 6px;}.mat-badge .mat-dot{width:9px;height:9px;}.mat-row{gap:4px;margin-bottom:8px;}}'
    ].join('');
    var st = document.createElement('style'); st.id = 'mat-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  var INDEX = null, loading = null;
  function fromCache() { try { var o = JSON.parse(sessionStorage.getItem(CONFIG.cacheKey) || 'null'); if (!o || Date.now() - o.t > CONFIG.cacheTtlMs) return null; return o.d; } catch (e) { return null; } }
  function toCache(d) { try { sessionStorage.setItem(CONFIG.cacheKey, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    var cached = fromCache(); if (cached) { INDEX = cached; return Promise.resolve(INDEX); }
    loading = (function () {
      var map = {};
      function page(n) {
        return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var ps = (j && j.products) || [], i;
            for (i = 0; i < ps.length; i++) { if (isManometro(ps[i])) map[ps[i].handle] = { b: bourdonOf(ps[i]), c: cajaOf(ps[i]) }; }
            if (ps.length === 250 && n < 8) return page(n + 1);
          });
      }
      return page(1).then(function () { INDEX = map; toCache(map); loading = null; return INDEX; })
        .catch(function () { loading = null; return (INDEX = INDEX || {}); });
    })();
    return loading;
  }

  function handleOf(card) {
    var a = card.querySelector(CONFIG.productLink); if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function chip(cls, label) { return '<span class="mat-badge ' + cls + '"><span class="mat-dot"></span>' + esc(label) + '</span>'; }

  function injectGrid() {
    if (!INDEX) return;
    document.querySelectorAll(CONFIG.card).forEach(function (card) {
      if (card.__matDone) return;
      var h = handleOf(card); if (!h) return;
      var rec = INDEX[h]; if (!rec) { card.__matDone = true; return; }
      var info = card.querySelector(CONFIG.cardInfo); if (!info) return;
      card.__matDone = true;
      var row = document.createElement('div'); row.className = 'mat-row';
      row.innerHTML = chip('mat-' + rec.b, BOURDON[rec.b]) + chip('mat-' + rec.c, CAJA[rec.c]);
      info.insertBefore(row, info.firstChild);
    });
  }

  function init() {
    injectCSS();
    loadIndex().then(function () {
      injectGrid();
      var host = document.querySelector(CONFIG.gridWatch);
      if (host && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { injectGrid(); });
        mo.observe(host, { childList: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
